import { Component } from '@angular/core';
import { MsDialPlanGroupsContext } from '../../contexts/ms-dial-plan-groups.context';
import { MsDialPlanExceptionGroupsContext } from '../../contexts/ms-dial-plan-exception-groups.context';

@Component({
  selector: 'ziro-tenant-management',
  template: '<router-outlet></router-outlet>',
  standalone: false,
  providers: [MsDialPlanGroupsContext, MsDialPlanExceptionGroupsContext],
})
export class TenantManagementComponent {}
